






import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class EstimateRow extends Vue {
  @Prop({ type: Boolean }) draggable!: boolean;
  @Prop({ required: true }) styleGridColumn!: string;
  @Prop({ required: true }) isShowNoteColumn!: boolean;

  get style() {
    return {
      "grid-template-columns": this.styleGridColumn,
      "min-width": this.isShowNoteColumn ? "1700px" : "1547px"
    };
  }
}
